const DownloadIcon = () => {
  return (
    <svg
      width="26"
      height="30"
      viewBox="0 0 26 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: '24px' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0703 0H14.1695V17.8426H12.0703V0ZM10.911 22.5507L5.86774 17.5075L7.25309 16.1222L12.2963 21.1654C12.6789 21.5479 13.2991 21.5479 13.6817 21.1654L18.7249 16.1222L20.1103 17.5075L15.067 22.5507C13.9194 23.6984 12.0586 23.6984 10.911 22.5507ZM0 15.0437H2.09913V27.9008L23.6152 27.9008V15.0437H25.7143V27.9008V30H23.6152H2.09913H0V27.9008V15.0437Z"
        fill="black"
      />
    </svg>
  );
};

export default DownloadIcon;
